import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { } from 'react-router-dom';
import { compose } from 'redux';
import {
  LayoutWrapperMain, Page, ReportUserInfo,
} from '../../components';
import config from '../../config';
import './reportuserinfo.global.scss';

interface Props {
  params: any;
  intl: any;
  scrollingDisabled: any;
}

const ReportUserInfoComponent: React.FC<Props> = (props: Props) => {
  const { intl, scrollingDisabled, params } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'ReportUserManagement.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <ReportUserInfo id={params.id} />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const ReportUserInfoComponentPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(ReportUserInfoComponent);

export default ReportUserInfoComponentPage;
